import has from 'lodash/has'

const getDeliveryGroupItems = (items, deliveryGroups) => {
    return deliveryGroups.map((deliveryGroup) => {
        const deliveryGroupCards = items.filter(
            (item) =>
                (has(item, 'delivery_group_uuid') &&
                    item.delivery_group_uuid === deliveryGroup.uuid) ||
                (has(item, 'deliveryGroupUuid') &&
                    item.deliveryGroupUuid === deliveryGroup.uuid)
        )

        if (
            has(deliveryGroupCards[0], 'delivery_group_uuid') &&
            has(deliveryGroupCards[0], 'custom_card_details.wcp_product')
        ) {
            return {
                aaa_item_class: 'wcp_open_loop',
                deliveryGroupId: deliveryGroup.uuid,
                deliveryStyle: deliveryGroup.delivery_style,
                isBoxset: deliveryGroup.is_boxset,
                includesTrifold: deliveryGroup.is_boxset,
                minGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (min, item) =>
                        Math.min(min, parseFloat(item.processing_fee)),
                    parseFloat(deliveryGroupCards[0].processing_fee)
                ),
                maxGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (max, card) =>
                        Math.max(max, parseFloat(card.processing_fee)),
                    parseFloat(deliveryGroupCards[0].processing_fee)
                ),
                minGroupCardPrice: deliveryGroupCards.reduce(
                    (min, card) => Math.min(min, parseFloat(card.price)),
                    parseFloat(deliveryGroupCards[0].price)
                ),
                maxGroupCardPrice: deliveryGroupCards.reduce(
                    (max, card) => Math.max(max, parseFloat(card.price)),
                    parseFloat(deliveryGroupCards[0].price)
                ),
                priceWithProcessingFees: deliveryGroupCards
                    .reduce(
                        (acc, card) =>
                            (acc +=
                                (card.quantity || 1) *
                                (parseFloat(card.price) +
                                    parseFloat(card.processing_fee))),
                        0
                    )
                    .toFixed(2),
                priceWithoutProcessingFees: deliveryGroupCards
                    .reduce(
                        (acc, card) =>
                            (acc +=
                                (card.quantity || 1) * parseFloat(card.price)),
                        0
                    )
                    .toFixed(2),
                quantityTotalForGroup: deliveryGroupCards.reduce(
                    (acc, card) => (acc += card.quantity || 1),
                    0
                ),
                product: {
                    cardNetwork:
                        deliveryGroupCards[0].custom_card_details.wcp_product
                            .card_network,
                    cardType:
                        deliveryGroupCards[0].custom_card_details.wcp_product
                            .card_type,
                    cardImageUrl:
                        window?.React?.cobrandProductId ===
                            `${deliveryGroupCards[0].custom_card_details.wcp_product.id}` ||
                        deliveryGroupCards[0].custom_card_details.wcp_product
                            .virtual_card
                            ? deliveryGroupCards[0].custom_card_image
                            : deliveryGroupCards[0].custom_card_details
                                  .wcp_product.raw_card_image_url ??
                              deliveryGroupCards[0].custom_card_details
                                  .wcp_product.card_image_url,
                    isVirtual:
                        deliveryGroupCards[0].custom_card_details.wcp_product
                            .virtual_card,
                },
                cards: deliveryGroupCards,
                shippingMethods: deliveryGroup.available_shipping_methods,
                selectedShippingMethod: deliveryGroup.shipping_method,
                bulkShippingName: deliveryGroup.bulk_shipping_name,
                shippingAddress: deliveryGroup.bulk_shipping_address,
            }
        }
        // Secondary original shape (SMB order details page)
        else if (
            has(deliveryGroupCards[0], 'deliveryGroupUuid') &&
            !has(deliveryGroupCards[0], 'sku')
        ) {
            return {
                aaa_item_class: 'wcp_closed_loop_delivery_grouped',
                deliveryGroupId: deliveryGroup.uuid,
                deliveryStyle: deliveryGroup.deliveryStyle,
                minGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (min, item) =>
                        Math.min(min, parseFloat(item.processingFee)),
                    parseFloat(deliveryGroupCards[0].processingFee)
                ),
                maxGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (max, card) =>
                        Math.max(max, parseFloat(card.processingFee)),
                    parseFloat(deliveryGroupCards[0].processingFee)
                ),
                minGroupCardPrice: deliveryGroupCards.reduce(
                    (min, card) => Math.min(min, parseFloat(card.price)),
                    parseFloat(deliveryGroupCards[0].price)
                ),
                maxGroupCardPrice: deliveryGroupCards.reduce(
                    (max, card) => Math.max(max, parseFloat(card.price)),
                    parseFloat(deliveryGroupCards[0].price)
                ),
                priceWithProcessingFees: deliveryGroupCards
                    .reduce(
                        (acc, card) =>
                            (acc +=
                                (card.quantity || 1) *
                                (parseFloat(card.price) +
                                    parseFloat(card.processingFee))),
                        0
                    )
                    .toFixed(2),
                priceWithoutProcessingFees: deliveryGroupCards
                    .reduce(
                        (acc, card) =>
                            (acc +=
                                (card.quantity || 1) * parseFloat(card.price)),
                        0
                    )
                    .toFixed(2),
                cashBackTotalForGroup: deliveryGroupCards.reduce(
                    (acc, card) => (acc += parseFloat(card.cash_back)),
                    0
                ),
                quantityTotalForGroup: deliveryGroupCards.reduce(
                    (acc, card) => (acc += card.quantity || 1),
                    0
                ),
                product: {
                    cardNetwork:
                        deliveryGroupCards[0].customCardDetails.wcpProduct
                            .cardNetwork,
                    cardType:
                        deliveryGroupCards[0].customCardDetails.wcpProduct
                            .cardType,
                    cardImageUrl:
                        window?.React?.cobrandProductId ===
                        `${deliveryGroupCards[0].custom_card_details.wcp_product?.id}`
                            ? deliveryGroupCards[0].customCardImage
                            : deliveryGroupCards[0].customCardDetails.wcpProduct
                                  ?.rawCardImageUrl ??
                              deliveryGroupCards[0].customCardDetails.wcpProduct
                                  .cardImageUrl,
                    isVirtual:
                        deliveryGroupCards[0].customCardDetails.wcpProduct
                            .virtualCard,
                },
                cards: deliveryGroupCards,
                shippingMethods: deliveryGroup.availableShippingMethods,
                selectedShippingMethod: deliveryGroup.shippingMethod,
                bulkShippingName: deliveryGroup.bulkShippingName,
                shippingAddress: deliveryGroup.bulkShippingAddress,
            }
        }
        // New alternate object shape
        else if (has(deliveryGroupCards[0], 'sku')) {
            const isBoxset = deliveryGroup.is_boxset
            const includesTrifold = deliveryGroupCards[0].open_loop
            const cardImageUrl =
                deliveryGroupCards[0].custom_card_image ??
                deliveryGroupCards[0].merchant?.logo_url ??
                '' //TODO need fallback here?

            return {
                aaa_item_class: 'wcp_closed_loop_other',
                deliveryGroupId: deliveryGroup.uuid,
                deliveryStyle: deliveryGroup.delivery_style,
                isBoxset: isBoxset,
                includesTrifold: includesTrifold,
                minGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (min, card) =>
                        Math.min(min, parseFloat(card.processing_fee)),
                    parseFloat(deliveryGroupCards[0].processing_fee)
                ),
                maxGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (max, card) =>
                        Math.max(max, parseFloat(card.processing_fee)),
                    parseFloat(deliveryGroupCards[0].processing_fee)
                ),
                minGroupCardPrice: deliveryGroupCards.reduce(
                    (min, card) => Math.min(min, parseFloat(card.price)),
                    parseFloat(deliveryGroupCards[0].price)
                ),
                maxGroupCardPrice: deliveryGroupCards.reduce(
                    (max, card) => Math.max(max, parseFloat(card.price)),
                    parseFloat(deliveryGroupCards[0].price)
                ),
                priceWithProcessingFees: deliveryGroupCards
                    .reduce(
                        (acc, card) =>
                            (acc +=
                                (card.quantity || 1) *
                                (parseFloat(card.price) +
                                    parseFloat(card.processing_fee))),
                        0
                    )
                    .toFixed(2),
                priceWithoutProcessingFees: deliveryGroupCards
                    .reduce(
                        (acc, card) =>
                            (acc +=
                                (card.quantity || 1) * parseFloat(card.price)),
                        0
                    )
                    .toFixed(2),
                cashBackTotalForGroup: deliveryGroupCards.reduce(
                    (acc, card) =>
                        (acc +=
                            (card.quantity || 1) * parseFloat(card.cash_back)),
                    0
                ),
                quantityTotalForGroup: deliveryGroupCards.reduce(
                    (acc, card) => (acc += card.quantity || 1),
                    0
                ),
                product: {
                    productName: deliveryGroupCards[0].product_name,
                    cardImageUrl: cardImageUrl,
                    isVirtual: deliveryGroupCards[0].plastic === false,
                },
                cards: deliveryGroupCards,
                shippingMethods: deliveryGroup.available_shipping_methods,
                selectedShippingMethod: deliveryGroup.shipping_method,
                bulkShippingName: deliveryGroup.bulk_shipping_name,
                shippingAddress: deliveryGroup.bulk_shipping_address,
            }
        }
        return null
    })
}

export default getDeliveryGroupItems
